:host {
  display: block;
}

.spw-modal {
  display: none;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1060;
  overflow-y: auto;

  &--opened {
    display: flex;
  }
}

.spw-modal__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.7;
  z-index: 0;
}

.spw-modal__content-container {
  position: absolute;
  display: flex;
  justify-content: center;
  width: 90%;
  background-color: #fff;
  box-shadow: var(--spw-effect-elevation-6);
  overflow: hidden;
  box-sizing: border-box;
  align-items: stretch;
  border-radius: var(--spw-spacings-border-radius-lg);

  &--small {
    max-width: 480px;
  }

  &--medium {
    max-width: 600px;
  }

  &--large {
    max-width: 768px;
  }

  &--fluid {
    max-width: 100%;
  }
}

.spw-modal__content {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--spw-color-themes-grey-grey-300);
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;

  .spw-modal--sticky-buttons & {
    overflow-y: visible;
  }
}

.spw-modal__icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  background-color: #fff;
  align-self: stretch;
}

.spw-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  padding-bottom: 0;
  margin-top: 6px;
  margin-bottom: 12px;
  box-sizing: border-box;
  border-radius: 1px 1px 0px 0px;
  color: var(--spw-colors-support-grey-grey-900);
}

.spw-modal__caption {
  overflow: hidden;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.spw-modal__header h2 {
  margin: 0;
  font-size: 18px;
  color: var(--spw-colors-support-grey-grey-900);
}

.spw-modal__header button {
  background: none;
  border: none;
  font-size: 1.5em;
  padding: 0;
  cursor: pointer;
}

.spw-modal__close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  font-size: 21px;
  &:hover {
    opacity: 0.7;
  }
}

.spw-modal__body {
  padding: 0 24px;
  margin-bottom: 12px;
  box-sizing: border-box;
  flex: 1;
  font-size: 16px;
  color: var(--spw-colors-support-grey-grey-700);

  .spw-modal--sticky-buttons & {
    overflow-y: auto;
  }
}

.spw-modal__buttons {
  ::slotted([slot='buttons']) {
    padding: 24px;
    padding-top: 12px;
  }
}

.spw-modal__footer--buttons-present ::slotted(*) {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 24px;
  padding-top: 8px;

  .spw-modal__content-container--small & {
    flex-direction: column;
    gap: 8px;
  }

  .spw-modal__content-container--medium & {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.spw-modal__border {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 1.5em;
  flex-grow: 1;
}
